module.exports = __webpack_public_path__ + "img/15.18cff688.png";